module.exports = __webpack_public_path__ + "img/it.8a584e14.jpeg";